/*eslint-disable */
/**
*金额处理工具
*/




function amount2Thousandth (amount) {
  if (amount === 0 || amount === '0') return 0
  if (amount === null || typeof amount === 'undefined') return
  let pointIndex = (amount.lastIndexOf(".") !== -1 ? amount.lastIndexOf(".") : amount.length)
  let thousandth = interger2Thousandth(amount.substring(0, pointIndex));
  let decimals = clearDecimalsEndZero(amount.substring(pointIndex, amount.length))
  if (thousandth.length === 0 && decimals.length === 0) return 0
  return ((thousandth.length === 0) ? '0' : thousandth) + (decimals.length === 0 ? '' : '.' + decimals)
}

function clearDecimalsEndZero (amount) {
  let pointIndex = amount.lastIndexOf(".");
  let pointPart = amount.substring(pointIndex + 1, amount.length);
  return pointPart.replace(/0+$/, '')
}

/**
 * 整数转千分位
 */
function interger2Thousandth (interger) {
  var re =/(-?\d+)(\d{3})/
  while (re.test(interger)) {
    interger = interger.replace(re,"$1,$2")
  }
  return interger
}

/**
 * 数字格式转换成千分位
 * @param{Object}num
 */
 function commafy(num){
   if((num+"").trim()==""){
    return"";
   }
   if(isNaN(num)){
    return num;
   }
   num = num+"";
   if(/^.*\..*$/.test(num)){
    var pointIndex =num.lastIndexOf(".");
    var intPart = num.substring(0,pointIndex);
    var pointPart =num.substring(pointIndex+1,num.length);
      intPart = intPart +"";
     var re =/(-?\d+)(\d{3})/
     while(re.test(intPart)){
      intPart =intPart.replace(re,"$1,$2")
     }
    num = intPart+"."+pointPart;
   }else{
    num = num +"";
     var re =/(-?\d+)(\d{3})/
     while(re.test(num)){
      num =num.replace(re,"$1,$2")
     }
   }
   return num;
 }

/**
 * 去除千分位
 *@param{Object}num
 */
function delcommafy(num){
  if((num+"").trim()==""){
   return"";
  }
  num = num + ''
  num=num.replace(/,/gi,'');
  return num;
}

/**
 * 处理金额、利率类显示函数  --- start ---
 * 扩大times倍传给后台，缩小times倍后显示（利率、比率为rateTimes倍）
 * @param： value：需要计算的值； isRate: 是否是利率，比率（默认：不是）
 */

 var times = 100
 var rateTimes = 10000

// 千分符 + 小数点后两位
function moneyShow (value) {
  value = moneyTools.delcommafy(value)
  if (isNaN(value) || value === '' || value === null) {
    return ''
  }
  return moneyTools.commafy(moneyTools.doubleDigit(value))
}

// 扩大 times 或 rateTimes 倍
function moneyExpand (value, isRate) {
  value = moneyTools.delcommafy(value)
  if (isNaN(value) || value === '' || value === null) {
    return ''
  }
  let expandNum = isRate ? rateTimes : times
  return value * expandNum
}

// 缩小times 或 rateTimes 倍
function moneyNarrow (value, isRate) {
  value = moneyTools.delcommafy(value)
  if (isNaN(value) || value === '' || value === null) {
    return ''
  }
  let narrowNum = isRate ? rateTimes : times
  return value / narrowNum
}

// 缩小times倍 + 千分符 + 小数点后两位
function moneyNarrowShow (value, num) {
  let narrowNum = num || times
  return moneyTools.moneyShow(value / narrowNum)
}

// 金额显示处理：千分符 + 可精确到小数点后四位
function moneyShowFour (value) {
  if (isNaN(value) || value === '' || value === null) {
    return ''
  }
  return moneyTools.commafy(moneyTools.fourDigit(value))
}

// 金额显示处理： 缩小times倍 + 千分符 + 小数点后两位
function moneyFourNarrow (value, num) {
  times = num || times
  if (isNaN(value) || value === '') {
    return ''
  }
  return moneyTools.commafy(moneyTools.fourDigit(value / times))
}

// 利率显示处理： 缩小times倍
function rateNarrow (value) {
  if (isNaN(value) || value === '') {
    return ''
  }
  return (value / times)
}

// 处理金额、利率类显示函数  --- end --- */

//金额拆分成小票的金额
function dealValue (value) {
  let sum = 11
  if (!value) return ['', '', '', '', '', '', '', '', '', '', '']
  if (!/^[0-9]+(.[0-9]{1,2})?$/.test(value)) {
    this.valueArray = []
    return
  }
  value = parseInt(accMul(parseFloat(delcommafy(value)).toFixed(2), 100))
  let array = value.toString().split('')
  let tempArray = []
  let i = 0
  while (i < sum) {
    tempArray.push('')
    i++
  }
  Array.map(array, (item, index) => {
    let l = sum - array.length + index
    tempArray[l] = item
  })
  return tempArray
}

function doubleDigit(value) {  // 保留两位小数
  if (isNaN(value) || value === '' || value === null) {
    return ''
  }
  var val = Math.round(parseFloat(value) * 10000) / 10000
  const num = val.toString().split('.')
  if (num.length === 1) {
    return val.toString() + '.00'
  } else if (num[1].length === 1) {
    return val.toString() + '0'
  } else if(num[1].length === 2){
    return val.toString()
  } else {
    return num[0] + "." + num[1].substring(0, 2)
  }
}

/**
 * 小数小于4位保留，大于4位截取
 *@param{Object}num
 */
function fourDigit (value) {
  if (isNaN(value) || value === '' || value === null) {
    return ''
  }
  const num = value.toString().split('.')
  if (num.length === 1) {
    return value.toString()
  } else if (num[1].length >= 4) {
    return num[0] + "." + num[1].substring(0, 4)
  } else {
    return value.toString()
  }
}

/*eslint-disable */
// 浮点型加减乘除
// 除法函数，用来得到精确的除法结果
// 说明：javascript的除法结果会有误差，在两个浮点数相除的时候会比较明显。这个函数返回较为精确的除法结果。
// 调用：accDiv(arg1,arg2)
// 返回值：arg1除以arg2的精确结果

function accDiv (arg1, arg2) {
  let t1=0,t2=0,r1,r2;
  try {
    t1 = arg1.toString().split('.')[1].length
  } catch (e) {

  }
  try {
    t2 = arg2.toString().split('.')[1].length
  } catch (e) {

  }
  r1 = Number(arg1.toString().replace('.', ''))
  r2 = Number(arg2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}
// 给Number类型增加一个div方法，调用起来更加方便。
Number.prototype.div = function (arg) {
  return accDiv(this, arg)
}

// 乘法函数，用来得到精确的乘法结果
// 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
// 调用：accMul(arg1,arg2)
// 返回值：arg1乘以arg2的精确结果
function accMul (arg1, arg2) {
  var m=0,s1=arg1.toString(),s2=arg2.toString();
  try {
    m += s1.split('.')[1].length
  } catch (e) {

  }
  try {
    m += s2.split('.')[1].length
  } catch (e) {

  }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
}
// 给Number类型增加一个mul方法，调用起来更加方便。
Number.prototype.mul = function (arg) {
  return accMul(arg, this)
}

// 加法函数，用来得到精确的加法结果
// 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
// 调用：accAdd(arg1,arg2)
// 返回值：arg1加上arg2的精确结果
function accAdd (arg1, arg2) {
var r1, r2, m
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}
// 给Number类型增加一个add方法，调用起来更加方便。
Number.prototype.add = function (arg) {
  return accAdd(arg, this)
}

// 减法函数，用来得到精确的减法结果
// 说明：javascript的减法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的减法结果。
// 调用：accSubtr(arg1,arg2)
// 返回值：arg1减去arg2的精确结果
function accSubtr (arg1, arg2) {
var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
// 动态控制精度长度
  n = (r1 >= r2) ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}
// 给Number类型增加一个subtr 方法，调用起来更加方便。
Number.prototype.subtr = function (arg) {
  return accSubtr(arg, this)
}
/*eslint-enable */

const moneyTools = {
  commafy: commafy,
  delcommafy: delcommafy,
  doubleDigit: doubleDigit,
  fourDigit: fourDigit,
  dealValue: dealValue,
  moneyShow: moneyShow,
  moneyShowFour: moneyShowFour,
  accDiv: accDiv, // float 除法
  accMul: accMul, // float 乘法
  accAdd: accAdd, // float 加法
  accSubtr: accSubtr, // float 减法
  moneyExpand: moneyExpand, // 金额扩大
  moneyNarrow: moneyNarrow, // 金额缩小
  moneyNarrowShow: moneyNarrowShow,
  moneyFourNarrow: moneyFourNarrow,
  rateNarrow: rateNarrow, // 比率缩小
  amount2Thousandth: amount2Thousandth
}

export default moneyTools
